<template>
  <div class="container-xl">
    <div class="card col-lg-12">
      <div class="card-header justify-content-between">
        <div class="card-title">
          <!-- App Home Sections -->
        </div>
        <el-button @click="handlerBtnContent" type="primary" size="mini"><font-awesome-icon icon="plus"/> Add categories</el-button>
      </div>
      <div class="table-responsive">
        <table class="table card-table text-nowrap table-vcenter">
          <thead>
            <tr>
              <th width="20%">Name</th>
              <th width="20%">Description</th>
              <th width="40%">Slug</th>
              <th>Status</th>
              <th>#</th>
            </tr>
          </thead>
          <tbody v-loading="loading.table">
            <tr v-for="item in list" :key="item.id">
              <td>{{ item.name }}</td>
              <td>{{ item.description }}</td>
              <td>{{ item.slug }}</td>
              <td>
                <span class="tag" :class="item.status_color">{{ item.status_str }}</span>
              </td>
              <td>
                <button class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown">Actions</button>
                  <div class="dropdown-menu dropdown-menu-right dropdown-menu-arrow p-2" style="width: 200px">
                    <a class="dropdown-item btn-sm cursor-pointer" @click="handlerBtnEdit(item)">
                      <font-awesome-icon class="text-primary" :icon="['fas', 'pen']"/>&nbsp; Edit Category
                    </a>
                    <a class="dropdown-item btn-sm cursor-pointer" @click="handlerBtnStatus(item)">
                      <font-awesome-icon class="text-warning" :icon="['fas', 'pen']"/>&nbsp; Update Status
                    </a>
                  </div>
              </td>
            </tr>
          </tbody>
        </table>
        <el-empty description="No data found" v-if="total_row == 0" :image="emptyStateImage"></el-empty>
      </div>
      <div class="card-footer d-flex justify-content-between">
          <small>Showing {{ showingFrom }} to {{ showingUntil }} of {{ total_row }} entries</small>
        <div class="inline-table">
          <b-pagination
            class="table-cell"
            @change="pageChangeHandler"
            :per-page="per_page"
            :limit="5"
            :total-rows="total_row"
            v-model="page"
          />
        </div>
      </div>
      <modal-section-categories-content
        @afterSubmit="handlerAfterSubmit"
        @onHide="isShownModalContent = false; selected_content = {}"
        :type="modalAction"
        :selected-content="selected_content"
        :show="isShownModalContent">
      </modal-section-categories-content>
      <modal-section-status-categories-content
        @afterSubmit="handlerAfterSubmit"
        @onHide="isShownModalStatusContent = false; selected_content = {}"
        :selected-content="selected_content"
        :show_status="isShownModalStatusContent">
      </modal-section-status-categories-content>
    </div>
  </div>
</template>
<script>
import { GET_SUB_CATEGORIES} from '@/store/modules/app_content';
import emptyStateImage from '@/assets/images/empty-state.png';
import popupErrorMessages from '@/library/popup-error-messages';
import ModalSectionCategoriesContent from './ModalSectionCategoriesContent.vue';
import ModalSectionStatusCategoriesContent from './ModalSectionStatusCategoriesContent.vue';

export default {
  name: 'GlobalSetting',
  components: {
    ModalSectionCategoriesContent,
    ModalSectionStatusCategoriesContent
  },
  metaInfo: {
    title: 'Categories Content',
  },
  data() {
    return {
      emptyStateImage,
      isShownModalContent: false,
      isShownModalStatusContent: false,
      loading: {
        modal_content: false,
        table: false,
      },
      modalAction: 'add',
      page: 1,
      per_page: 10,
      list: [],
      total_row: 0,
      selected_content: {},
    };
  },
  mounted() {
    this.getList();
  },
  computed: {
    showingFrom() {
      return this.total_row ? ((this.page - 1) * this.per_page) + 1 : 0;
    },
    showingUntil() {
      if (this.total_row) {
        if (this.list.length < this.per_page) {
          return this.total_row;
        }
        return this.page * this.per_page;
      }
      return 0;
    },
  },
  methods: {
    handlerCloseModalContent() {
      this.isShownModalContent = false;
      this.isShownModalStausContent = false;
    },
    handlerBtnContent() {
      this.isShownModalContent = true;
    },
    handlerAfterSubmit() {
      this.isShownModalContent = false;
      this.isShownModalStatusContent = false;
      this.getList();
    },
    pageChangeHandler(page) {
      this.page = page;
      this.getList();
    },
    handlerBtnEdit(item) {
      this.selected_content = item;
      this.isShownModalContent = true;
      this.modalAction = 'edit';
    },
    handlerBtnStatus(item) {
      this.selected_content = item;
      this.isShownModalStatusContent = true;
      this.modalAction = 'update';
    },
    async getList() {
      this.loading.table = true;
      await this.$store.dispatch(GET_SUB_CATEGORIES, {
        page: this.page,
        per_page: this.per_page,
      }).catch((err) => {
        popupErrorMessages(err);
      });
      this.loading.table = false;
      const response = this.$store.getters.content_categories;
      this.list = response.rows;
      this.total_row = response.count;
      // console.log('List:', this.list);
      // console.log('Total Rows:', this.total_row);
    },
  },
};
</script>